module.exports = __webpack_public_path__ + "static/media/delfi.cb0136f8.jpg";